import type { ChipsSummaryResp } from '@/generated/graphql';

export interface IChipsSummary {
  cashiersChips: number;
  playerChips: number;
  terminalChips: number;
  terminalLimit: number;
  usherChips: number;
}

export function mapGQLChipsSummary(chipsSummary?: ChipsSummaryResp | null): IChipsSummary {
  return {
    cashiersChips: chipsSummary?.cashiersChips ?? 0,
    playerChips: chipsSummary?.playerChips ?? 0,
    usherChips: chipsSummary?.usherChips ?? 0,
    terminalChips: chipsSummary?.terminalChips ?? 0,
    terminalLimit: chipsSummary?.terminalLimit ?? 0,
  };
}
